import { Outlet } from 'react-router-dom';

import { PwaChrome } from '@/components/pwa/PwaChrome';
import { PaymentPrivacyBoundary } from '@/components/analytics/PaymentPrivacyBoundary';

export function RouteChrome() {
  return (
    <>
      <PaymentPrivacyBoundary />
      <Outlet />
      <PwaChrome />
    </>
  );
}
